module.exports = __webpack_public_path__ + "img/phone.4fdfa624.png";